'use client';

import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { formatEarnSunsetDisplayDate } from '@flipster/utils/earn-sunset';

export const EarnSunsetNewInfoLine = () => {
  const date = formatEarnSunsetDisplayDate();

  return (
    <p
      className={css({
        w: '100%',
        textAlign: 'center',
        textStyle: 'Body/S/Regular',
        color: 'content.default.level-4',
      })}
    >
      <FormattedMessage
        id='Earn.r260827.Premium_earn_sunset_disclaimer'
        values={{
          date: (
            <span key='date' className={css({ color: 'content.state.warning' })}>
              {date}
            </span>
          ),
        }}
      />
    </p>
  );
};
